let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("knDxd")).then(() => parcelRequire('91VcN'));